import UserIcon from '@mui/icons-material/Person';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import { getBusinessGlobalContacts } from 'lib/api/contacts';
import { Contact } from 'lib/api/contacts/types';
import ContactsTable from 'lib/common/Tables/ContactsTable';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import DialogTitle from 'lib/designSystem/Title/DialogTitle';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import AddConfirmationDialog from './AddConfirmationDialog';

const EmptyNetwork = () => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" py={3}>
      <Stack spacing={1} alignItems="center">
        <UserIcon sx={{ color: 'text.disabled', fontSize: 40 }} />
        <Typography variant="body2" color="text.secondary">
          La empresa no tiene contactos en la red.
        </Typography>
      </Stack>
    </Box>
  );
};

const ContactNetwork = ({
  open,
  setOpen,
  identifier,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  identifier?: string;
}) => {
  const dispatch = useDispatch();
  const { data, isPending } = getBusinessGlobalContacts(dispatch, identifier);
  const [selectedContact, setSelectedContact] = useState<Contact | null>(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);

  const contacts = data?.items ?? [];

  const handleContactSelect = (contactId: number) => {
    const contact = contacts.find((contact) => contact.id === contactId);
    if (!contact) return;
    setSelectedContact(contact);
    setConfirmationOpen(true);
  };

  const handleConfirmationSuccess = () => {
    setConfirmationOpen(false);
    setSelectedContact(null);
    setOpen(false);
  };

  if (isPending) return <CenteredCircularProgress type="dialog" />;

  return (
    <>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          onClose={() => setOpen(false)}
          title="Buscar contacto en red"
          icon={<SearchIcon color="primary" />}
          color="primary"
        />
        <DialogContent>
          {contacts && contacts.length > 0 ? (
            <ContactsTable
              data={contacts || []}
              handleClick={handleContactSelect}
              showIdentifier={false}
              showObservation={false}
              showCountry={false}
              showProfession={false}
              showMaritalStatus={false}
              showActions={false}
              showProfiles={false}
            />
          ) : (
            <EmptyNetwork />
          )}
        </DialogContent>
      </Dialog>

      {selectedContact && (
        <AddConfirmationDialog
          open={confirmationOpen}
          setOpen={setConfirmationOpen}
          contact={selectedContact}
          onSuccess={handleConfirmationSuccess}
        />
      )}
    </>
  );
};

export default ContactNetwork;
